import type { SortDirection } from "./types";

export interface ISortingData<D> {
    dataIndex: D;
    sortDirection: SortDirection;
}

export interface ITableState<F extends object, D> {
    currentPage: number;
    searchTerm: string;
    sorting: ISortingData<D>;
    filterState: F;
}

export type TableAction<F extends object, D> =
    | { type: "RESET_TABLE"; payload?: { sorting?: ISortingData<D> } }
    | { type: "RESET_PAGE" }
    | { type: "SET_PAGE"; payload: number }
    | { type: "SET_SEARCH"; payload: string }
    | { type: "SET_SORTING"; payload: ISortingData<D> }
    | { type: "SET_SORTING_AND_RESET_PAGE"; payload: ISortingData<D> }
    | { type: "SET_FILTERS"; payload: F };

export const tableReducer = <F extends object, D>(
    state: ITableState<F, D>,
    action: TableAction<F, D>,
): ITableState<F, D> => {
    switch (action.type) {
        case "RESET_TABLE":
            return {
                ...state,
                currentPage: 1,
                searchTerm: "",
                filterState: {} as F,
                ...(action.payload?.sorting && { sorting: action.payload.sorting }),
            };
        case "RESET_PAGE":
            return {
                ...state,
                currentPage: 1,
            };
        case "SET_PAGE":
            return {
                ...state,
                currentPage: action.payload,
            };
        case "SET_SEARCH":
            return {
                ...state,
                searchTerm: action.payload,
                currentPage: 1,
            };
        case "SET_SORTING":
            return {
                ...state,
                sorting: action.payload,
            };
        case "SET_SORTING_AND_RESET_PAGE":
            return {
                ...state,
                sorting: action.payload,
                currentPage: 1,
            };
        case "SET_FILTERS":
            return {
                ...state,
                filterState: action.payload,
                currentPage: 1,
            };
        default:
            return state;
    }
};
